export default __webpack_public_path__ + "static/kynnet4-31395b95e973abd54659defa1ed658b7.jpeg";